export const TEXT_LIMIT = 3000;
